import {
  ApplicationRef,
  ComponentRef,
  createComponent,
  EnvironmentInjector,
  inject,
  Injectable,
  Injector,
  Type,
} from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { BottomMenuModalComponent } from './bottom-menu-modal/bottom-menu-modal.component';

export interface FgbModalOptions {
  marginTop?: number;
  minHeight?: number;
  animate?: boolean;
  startY?: number;
  draggable?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class FgbModalService {
  private modalRef?: ComponentRef<any>;
  private injector = inject(Injector);
  private appRef = inject(ApplicationRef);
  isOpen: boolean = false;

  private openModal<T>(modalComponent: any, component: Type<T>, inputs?: Partial<T> | null, options?: FgbModalOptions) {
    if (this.modalRef) return;
    this.isOpen = true;
    this.modalRef = createComponent(modalComponent, {
      environmentInjector: this.injector.get(EnvironmentInjector),
      elementInjector: this.injector,
    });

    if (options) {
      Object.assign(this.modalRef.instance as any, options);
    }

    this.appRef.attachView(this.modalRef.hostView);

    const domElem = this.modalRef.location.nativeElement;
    document.body.appendChild(domElem);

    const innerComponentRef = createComponent(component, {
      environmentInjector: this.injector.get(EnvironmentInjector),
      elementInjector: this.injector,
    });

    if (inputs) {
      Object.assign(innerComponentRef.instance as any, inputs);
    }

    this.modalRef.instance.insertComponent(innerComponentRef);
    this.modalRef.instance.closed.subscribe(() => this.close());
  }

  openBottomMenu<T>(component: Type<T>, inputs?: Partial<T> | null, options?: FgbModalOptions): void {
    this.openModal(BottomMenuModalComponent, component, inputs, options);
  }

  close(): void {
    if (!this.modalRef) return;
    this.modalRef.instance.close(() => {
      this.isOpen = false;
      this.appRef.detachView(this.modalRef!.hostView);
      this.modalRef!.destroy();
      this.modalRef = undefined;
    });
  }

  get positionChange$(): Observable<any> {
    if (!this.modalRef) return EMPTY;
    return this.modalRef.instance.draggingChange.asObservable();
  }

  get closed$(): Observable<any> {
    if (!this.modalRef) return EMPTY;
    return this.modalRef.instance.closed.asObservable();
  }

  get el() {
    if (!this.modalRef) return null;
    return this.modalRef.location.nativeElement;
  }
}
